<template>
  <div class="section-title d-flex align-items-center">
    <div class="vertual-moduling"></div>
    <div class="title">{{ title }}</div>
  </div>
</template>
<script>
export default {
  name: 'section-title',
  props: {
    title: {
      type: String,
      default: '标题',
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
};
</script>
<style scoped>
.section-header {
  padding: 0 1rem 0 0.5rem;
}
.vertual-moduling {
  width: 4px;
  height: 1.5rem;
  background-color: #2e9bf3;
}
.title {
  font-size: 1.2rem;
  margin: 0 0.6rem;
}
</style>
